import React, { useEffect } from 'react';
import 'intl-tel-input/build/css/intlTelInput.css';
import './App.css';
import './assets/poppins/poppins.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AppContextProvider} from './contexts/AppContext'
import Routes from './routes';
import {BrowserRouter} from "react-router-dom";
import DommusPromiseLoading from "./components/DommusLoading/DommusPromiseLoading";
import urlHelper from './helpers/UrlHelper';
import caAPI from './services/caAPI';
import Swal from 'sweetalert2';

function App() {
	useEffect(() => {
		const tokenGu = caAPI.getLocalState('guToken')
		if(!urlHelper.getCookie('gu_access_token')) {
			if(tokenGu) {
				document.cookie = `gu_access_token=${tokenGu}; path=/; domain=.dommus.com.br; SameSite=Lax`;
			} else {
				Swal.fire('Login Expirado!', 'Por favor, faça login novamente.', 'warning').then(() => {
					caAPI.logout()
				})
			}
		}
	}, [])

	return (
		<BrowserRouter>
			<DommusPromiseLoading/>
			<AppContextProvider>
				<Routes/>
			</AppContextProvider>
		</BrowserRouter>

	);
}

export default App;
